// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"MetaDataList_wrapper__Lmy8r"};